export default {
  // Title
  title: "Scan to Bind",

  // Loading
  loading: "Loading...",

  // Platform Name
  wechat: "WeChat",
};
